export { default as VerticalCarouselItem } from './VerticalCarouselItem';
export type { VerticalCarouselItemProps } from './types';
